import { render, staticRenderFns } from "./OrderScheduling.vue?vue&type=template&id=0be2d8d6&"
import script from "./OrderScheduling.vue?vue&type=script&lang=ts&"
export * from "./OrderScheduling.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports